import { Icon, Icons } from 'components/Icon';
import React from 'react';

type IProps = {
  iconColor: string;
  bgColor: string;
  type: string;
  typeCount: number | undefined;
};

export default function WillStatCard({
  iconColor,
  bgColor,
  type,
  typeCount
}: IProps) {
  return (
    <div>
      <div
        className="relative flex w-72 overflow-hidden rounded-md p-16"
        style={{ backgroundColor: bgColor }}
      >
        <Icon name={Icons.CircleUp} fill={iconColor} />
        <Icon name={Icons.CircleDown} fill={iconColor} />
        <span className="absolute left-0 top-0 p-4 text-lg font-bold text-white">
          {type}
        </span>
        <span className="absolute bottom-0 right-0 p-4 text-6xl font-bold text-white">
          {typeCount ?? 0}
        </span>
      </div>
    </div>
  );
}
